var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_431_5643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 480,
    height: 480
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    fill: "url(#paint0_radial_431_5643)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_431_5643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5C10.8284 8.5 11.5 9.17157 11.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 10C34.5 10.8284 33.8284 11.5 33 11.5C32.1716 11.5 31.5 10.8284 31.5 10C31.5 9.17157 32.1716 8.5 33 8.5C33.8284 8.5 34.5 9.17157 34.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 10C57.5 10.8284 56.8284 11.5 56 11.5C55.1716 11.5 54.5 10.8284 54.5 10C54.5 9.17157 55.1716 8.5 56 8.5C56.8284 8.5 57.5 9.17157 57.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 10C80.5 10.8284 79.8284 11.5 79 11.5C78.1716 11.5 77.5 10.8284 77.5 10C77.5 9.17157 78.1716 8.5 79 8.5C79.8284 8.5 80.5 9.17157 80.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 10C103.5 10.8284 102.828 11.5 102 11.5C101.172 11.5 100.5 10.8284 100.5 10C100.5 9.17157 101.172 8.5 102 8.5C102.828 8.5 103.5 9.17157 103.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 10C126.5 10.8284 125.828 11.5 125 11.5C124.172 11.5 123.5 10.8284 123.5 10C123.5 9.17157 124.172 8.5 125 8.5C125.828 8.5 126.5 9.17157 126.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 10C149.5 10.8284 148.828 11.5 148 11.5C147.172 11.5 146.5 10.8284 146.5 10C146.5 9.17157 147.172 8.5 148 8.5C148.828 8.5 149.5 9.17157 149.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 10C172.5 10.8284 171.828 11.5 171 11.5C170.172 11.5 169.5 10.8284 169.5 10C169.5 9.17157 170.172 8.5 171 8.5C171.828 8.5 172.5 9.17157 172.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 10C195.5 10.8284 194.828 11.5 194 11.5C193.172 11.5 192.5 10.8284 192.5 10C192.5 9.17157 193.172 8.5 194 8.5C194.828 8.5 195.5 9.17157 195.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 10C218.5 10.8284 217.828 11.5 217 11.5C216.172 11.5 215.5 10.8284 215.5 10C215.5 9.17157 216.172 8.5 217 8.5C217.828 8.5 218.5 9.17157 218.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 10C241.5 10.8284 240.828 11.5 240 11.5C239.172 11.5 238.5 10.8284 238.5 10C238.5 9.17157 239.172 8.5 240 8.5C240.828 8.5 241.5 9.17157 241.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 10C264.5 10.8284 263.828 11.5 263 11.5C262.172 11.5 261.5 10.8284 261.5 10C261.5 9.17157 262.172 8.5 263 8.5C263.828 8.5 264.5 9.17157 264.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 10C287.5 10.8284 286.828 11.5 286 11.5C285.172 11.5 284.5 10.8284 284.5 10C284.5 9.17157 285.172 8.5 286 8.5C286.828 8.5 287.5 9.17157 287.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 10C310.5 10.8284 309.828 11.5 309 11.5C308.172 11.5 307.5 10.8284 307.5 10C307.5 9.17157 308.172 8.5 309 8.5C309.828 8.5 310.5 9.17157 310.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 10C333.5 10.8284 332.828 11.5 332 11.5C331.172 11.5 330.5 10.8284 330.5 10C330.5 9.17157 331.172 8.5 332 8.5C332.828 8.5 333.5 9.17157 333.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 10C356.5 10.8284 355.828 11.5 355 11.5C354.172 11.5 353.5 10.8284 353.5 10C353.5 9.17157 354.172 8.5 355 8.5C355.828 8.5 356.5 9.17157 356.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 10C379.5 10.8284 378.828 11.5 378 11.5C377.172 11.5 376.5 10.8284 376.5 10C376.5 9.17157 377.172 8.5 378 8.5C378.828 8.5 379.5 9.17157 379.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 10C402.5 10.8284 401.828 11.5 401 11.5C400.172 11.5 399.5 10.8284 399.5 10C399.5 9.17157 400.172 8.5 401 8.5C401.828 8.5 402.5 9.17157 402.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 10C425.5 10.8284 424.828 11.5 424 11.5C423.172 11.5 422.5 10.8284 422.5 10C422.5 9.17157 423.172 8.5 424 8.5C424.828 8.5 425.5 9.17157 425.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 10C448.5 10.8284 447.828 11.5 447 11.5C446.172 11.5 445.5 10.8284 445.5 10C445.5 9.17157 446.172 8.5 447 8.5C447.828 8.5 448.5 9.17157 448.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 10C471.5 10.8284 470.828 11.5 470 11.5C469.172 11.5 468.5 10.8284 468.5 10C468.5 9.17157 469.172 8.5 470 8.5C470.828 8.5 471.5 9.17157 471.5 10Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 33C11.5 33.8284 10.8284 34.5 10 34.5C9.17157 34.5 8.5 33.8284 8.5 33C8.5 32.1716 9.17157 31.5 10 31.5C10.8284 31.5 11.5 32.1716 11.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 33C34.5 33.8284 33.8284 34.5 33 34.5C32.1716 34.5 31.5 33.8284 31.5 33C31.5 32.1716 32.1716 31.5 33 31.5C33.8284 31.5 34.5 32.1716 34.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 33C57.5 33.8284 56.8284 34.5 56 34.5C55.1716 34.5 54.5 33.8284 54.5 33C54.5 32.1716 55.1716 31.5 56 31.5C56.8284 31.5 57.5 32.1716 57.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 33C80.5 33.8284 79.8284 34.5 79 34.5C78.1716 34.5 77.5 33.8284 77.5 33C77.5 32.1716 78.1716 31.5 79 31.5C79.8284 31.5 80.5 32.1716 80.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 33C103.5 33.8284 102.828 34.5 102 34.5C101.172 34.5 100.5 33.8284 100.5 33C100.5 32.1716 101.172 31.5 102 31.5C102.828 31.5 103.5 32.1716 103.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 33C126.5 33.8284 125.828 34.5 125 34.5C124.172 34.5 123.5 33.8284 123.5 33C123.5 32.1716 124.172 31.5 125 31.5C125.828 31.5 126.5 32.1716 126.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 33C149.5 33.8284 148.828 34.5 148 34.5C147.172 34.5 146.5 33.8284 146.5 33C146.5 32.1716 147.172 31.5 148 31.5C148.828 31.5 149.5 32.1716 149.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 33C172.5 33.8284 171.828 34.5 171 34.5C170.172 34.5 169.5 33.8284 169.5 33C169.5 32.1716 170.172 31.5 171 31.5C171.828 31.5 172.5 32.1716 172.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 33C195.5 33.8284 194.828 34.5 194 34.5C193.172 34.5 192.5 33.8284 192.5 33C192.5 32.1716 193.172 31.5 194 31.5C194.828 31.5 195.5 32.1716 195.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 33C218.5 33.8284 217.828 34.5 217 34.5C216.172 34.5 215.5 33.8284 215.5 33C215.5 32.1716 216.172 31.5 217 31.5C217.828 31.5 218.5 32.1716 218.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 33C241.5 33.8284 240.828 34.5 240 34.5C239.172 34.5 238.5 33.8284 238.5 33C238.5 32.1716 239.172 31.5 240 31.5C240.828 31.5 241.5 32.1716 241.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 33C264.5 33.8284 263.828 34.5 263 34.5C262.172 34.5 261.5 33.8284 261.5 33C261.5 32.1716 262.172 31.5 263 31.5C263.828 31.5 264.5 32.1716 264.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 33C287.5 33.8284 286.828 34.5 286 34.5C285.172 34.5 284.5 33.8284 284.5 33C284.5 32.1716 285.172 31.5 286 31.5C286.828 31.5 287.5 32.1716 287.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 33C310.5 33.8284 309.828 34.5 309 34.5C308.172 34.5 307.5 33.8284 307.5 33C307.5 32.1716 308.172 31.5 309 31.5C309.828 31.5 310.5 32.1716 310.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 33C333.5 33.8284 332.828 34.5 332 34.5C331.172 34.5 330.5 33.8284 330.5 33C330.5 32.1716 331.172 31.5 332 31.5C332.828 31.5 333.5 32.1716 333.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 33C356.5 33.8284 355.828 34.5 355 34.5C354.172 34.5 353.5 33.8284 353.5 33C353.5 32.1716 354.172 31.5 355 31.5C355.828 31.5 356.5 32.1716 356.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 33C379.5 33.8284 378.828 34.5 378 34.5C377.172 34.5 376.5 33.8284 376.5 33C376.5 32.1716 377.172 31.5 378 31.5C378.828 31.5 379.5 32.1716 379.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 33C402.5 33.8284 401.828 34.5 401 34.5C400.172 34.5 399.5 33.8284 399.5 33C399.5 32.1716 400.172 31.5 401 31.5C401.828 31.5 402.5 32.1716 402.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 33C425.5 33.8284 424.828 34.5 424 34.5C423.172 34.5 422.5 33.8284 422.5 33C422.5 32.1716 423.172 31.5 424 31.5C424.828 31.5 425.5 32.1716 425.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 33C448.5 33.8284 447.828 34.5 447 34.5C446.172 34.5 445.5 33.8284 445.5 33C445.5 32.1716 446.172 31.5 447 31.5C447.828 31.5 448.5 32.1716 448.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 33C471.5 33.8284 470.828 34.5 470 34.5C469.172 34.5 468.5 33.8284 468.5 33C468.5 32.1716 469.172 31.5 470 31.5C470.828 31.5 471.5 32.1716 471.5 33Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 56C11.5 56.8284 10.8284 57.5 10 57.5C9.17157 57.5 8.5 56.8284 8.5 56C8.5 55.1716 9.17157 54.5 10 54.5C10.8284 54.5 11.5 55.1716 11.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 56C34.5 56.8284 33.8284 57.5 33 57.5C32.1716 57.5 31.5 56.8284 31.5 56C31.5 55.1716 32.1716 54.5 33 54.5C33.8284 54.5 34.5 55.1716 34.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 56C57.5 56.8284 56.8284 57.5 56 57.5C55.1716 57.5 54.5 56.8284 54.5 56C54.5 55.1716 55.1716 54.5 56 54.5C56.8284 54.5 57.5 55.1716 57.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 56C80.5 56.8284 79.8284 57.5 79 57.5C78.1716 57.5 77.5 56.8284 77.5 56C77.5 55.1716 78.1716 54.5 79 54.5C79.8284 54.5 80.5 55.1716 80.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 56C103.5 56.8284 102.828 57.5 102 57.5C101.172 57.5 100.5 56.8284 100.5 56C100.5 55.1716 101.172 54.5 102 54.5C102.828 54.5 103.5 55.1716 103.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 56C126.5 56.8284 125.828 57.5 125 57.5C124.172 57.5 123.5 56.8284 123.5 56C123.5 55.1716 124.172 54.5 125 54.5C125.828 54.5 126.5 55.1716 126.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 56C149.5 56.8284 148.828 57.5 148 57.5C147.172 57.5 146.5 56.8284 146.5 56C146.5 55.1716 147.172 54.5 148 54.5C148.828 54.5 149.5 55.1716 149.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 56C172.5 56.8284 171.828 57.5 171 57.5C170.172 57.5 169.5 56.8284 169.5 56C169.5 55.1716 170.172 54.5 171 54.5C171.828 54.5 172.5 55.1716 172.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 56C195.5 56.8284 194.828 57.5 194 57.5C193.172 57.5 192.5 56.8284 192.5 56C192.5 55.1716 193.172 54.5 194 54.5C194.828 54.5 195.5 55.1716 195.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 56C218.5 56.8284 217.828 57.5 217 57.5C216.172 57.5 215.5 56.8284 215.5 56C215.5 55.1716 216.172 54.5 217 54.5C217.828 54.5 218.5 55.1716 218.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 56C241.5 56.8284 240.828 57.5 240 57.5C239.172 57.5 238.5 56.8284 238.5 56C238.5 55.1716 239.172 54.5 240 54.5C240.828 54.5 241.5 55.1716 241.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 56C264.5 56.8284 263.828 57.5 263 57.5C262.172 57.5 261.5 56.8284 261.5 56C261.5 55.1716 262.172 54.5 263 54.5C263.828 54.5 264.5 55.1716 264.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 56C287.5 56.8284 286.828 57.5 286 57.5C285.172 57.5 284.5 56.8284 284.5 56C284.5 55.1716 285.172 54.5 286 54.5C286.828 54.5 287.5 55.1716 287.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 56C310.5 56.8284 309.828 57.5 309 57.5C308.172 57.5 307.5 56.8284 307.5 56C307.5 55.1716 308.172 54.5 309 54.5C309.828 54.5 310.5 55.1716 310.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 56C333.5 56.8284 332.828 57.5 332 57.5C331.172 57.5 330.5 56.8284 330.5 56C330.5 55.1716 331.172 54.5 332 54.5C332.828 54.5 333.5 55.1716 333.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 56C356.5 56.8284 355.828 57.5 355 57.5C354.172 57.5 353.5 56.8284 353.5 56C353.5 55.1716 354.172 54.5 355 54.5C355.828 54.5 356.5 55.1716 356.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 56C379.5 56.8284 378.828 57.5 378 57.5C377.172 57.5 376.5 56.8284 376.5 56C376.5 55.1716 377.172 54.5 378 54.5C378.828 54.5 379.5 55.1716 379.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 56C402.5 56.8284 401.828 57.5 401 57.5C400.172 57.5 399.5 56.8284 399.5 56C399.5 55.1716 400.172 54.5 401 54.5C401.828 54.5 402.5 55.1716 402.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 56C425.5 56.8284 424.828 57.5 424 57.5C423.172 57.5 422.5 56.8284 422.5 56C422.5 55.1716 423.172 54.5 424 54.5C424.828 54.5 425.5 55.1716 425.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 56C448.5 56.8284 447.828 57.5 447 57.5C446.172 57.5 445.5 56.8284 445.5 56C445.5 55.1716 446.172 54.5 447 54.5C447.828 54.5 448.5 55.1716 448.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 56C471.5 56.8284 470.828 57.5 470 57.5C469.172 57.5 468.5 56.8284 468.5 56C468.5 55.1716 469.172 54.5 470 54.5C470.828 54.5 471.5 55.1716 471.5 56Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 79C11.5 79.8284 10.8284 80.5 10 80.5C9.17157 80.5 8.5 79.8284 8.5 79C8.5 78.1716 9.17157 77.5 10 77.5C10.8284 77.5 11.5 78.1716 11.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 79C34.5 79.8284 33.8284 80.5 33 80.5C32.1716 80.5 31.5 79.8284 31.5 79C31.5 78.1716 32.1716 77.5 33 77.5C33.8284 77.5 34.5 78.1716 34.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 79C57.5 79.8284 56.8284 80.5 56 80.5C55.1716 80.5 54.5 79.8284 54.5 79C54.5 78.1716 55.1716 77.5 56 77.5C56.8284 77.5 57.5 78.1716 57.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 79C80.5 79.8284 79.8284 80.5 79 80.5C78.1716 80.5 77.5 79.8284 77.5 79C77.5 78.1716 78.1716 77.5 79 77.5C79.8284 77.5 80.5 78.1716 80.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 79C103.5 79.8284 102.828 80.5 102 80.5C101.172 80.5 100.5 79.8284 100.5 79C100.5 78.1716 101.172 77.5 102 77.5C102.828 77.5 103.5 78.1716 103.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 79C126.5 79.8284 125.828 80.5 125 80.5C124.172 80.5 123.5 79.8284 123.5 79C123.5 78.1716 124.172 77.5 125 77.5C125.828 77.5 126.5 78.1716 126.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 79C149.5 79.8284 148.828 80.5 148 80.5C147.172 80.5 146.5 79.8284 146.5 79C146.5 78.1716 147.172 77.5 148 77.5C148.828 77.5 149.5 78.1716 149.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 79C172.5 79.8284 171.828 80.5 171 80.5C170.172 80.5 169.5 79.8284 169.5 79C169.5 78.1716 170.172 77.5 171 77.5C171.828 77.5 172.5 78.1716 172.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 79C195.5 79.8284 194.828 80.5 194 80.5C193.172 80.5 192.5 79.8284 192.5 79C192.5 78.1716 193.172 77.5 194 77.5C194.828 77.5 195.5 78.1716 195.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 79C218.5 79.8284 217.828 80.5 217 80.5C216.172 80.5 215.5 79.8284 215.5 79C215.5 78.1716 216.172 77.5 217 77.5C217.828 77.5 218.5 78.1716 218.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 79C241.5 79.8284 240.828 80.5 240 80.5C239.172 80.5 238.5 79.8284 238.5 79C238.5 78.1716 239.172 77.5 240 77.5C240.828 77.5 241.5 78.1716 241.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 79C264.5 79.8284 263.828 80.5 263 80.5C262.172 80.5 261.5 79.8284 261.5 79C261.5 78.1716 262.172 77.5 263 77.5C263.828 77.5 264.5 78.1716 264.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 79C287.5 79.8284 286.828 80.5 286 80.5C285.172 80.5 284.5 79.8284 284.5 79C284.5 78.1716 285.172 77.5 286 77.5C286.828 77.5 287.5 78.1716 287.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 79C310.5 79.8284 309.828 80.5 309 80.5C308.172 80.5 307.5 79.8284 307.5 79C307.5 78.1716 308.172 77.5 309 77.5C309.828 77.5 310.5 78.1716 310.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 79C333.5 79.8284 332.828 80.5 332 80.5C331.172 80.5 330.5 79.8284 330.5 79C330.5 78.1716 331.172 77.5 332 77.5C332.828 77.5 333.5 78.1716 333.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 79C356.5 79.8284 355.828 80.5 355 80.5C354.172 80.5 353.5 79.8284 353.5 79C353.5 78.1716 354.172 77.5 355 77.5C355.828 77.5 356.5 78.1716 356.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 79C379.5 79.8284 378.828 80.5 378 80.5C377.172 80.5 376.5 79.8284 376.5 79C376.5 78.1716 377.172 77.5 378 77.5C378.828 77.5 379.5 78.1716 379.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 79C402.5 79.8284 401.828 80.5 401 80.5C400.172 80.5 399.5 79.8284 399.5 79C399.5 78.1716 400.172 77.5 401 77.5C401.828 77.5 402.5 78.1716 402.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 79C425.5 79.8284 424.828 80.5 424 80.5C423.172 80.5 422.5 79.8284 422.5 79C422.5 78.1716 423.172 77.5 424 77.5C424.828 77.5 425.5 78.1716 425.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 79C448.5 79.8284 447.828 80.5 447 80.5C446.172 80.5 445.5 79.8284 445.5 79C445.5 78.1716 446.172 77.5 447 77.5C447.828 77.5 448.5 78.1716 448.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 79C471.5 79.8284 470.828 80.5 470 80.5C469.172 80.5 468.5 79.8284 468.5 79C468.5 78.1716 469.172 77.5 470 77.5C470.828 77.5 471.5 78.1716 471.5 79Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 102C11.5 102.828 10.8284 103.5 10 103.5C9.17157 103.5 8.5 102.828 8.5 102C8.5 101.172 9.17157 100.5 10 100.5C10.8284 100.5 11.5 101.172 11.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 102C34.5 102.828 33.8284 103.5 33 103.5C32.1716 103.5 31.5 102.828 31.5 102C31.5 101.172 32.1716 100.5 33 100.5C33.8284 100.5 34.5 101.172 34.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 102C57.5 102.828 56.8284 103.5 56 103.5C55.1716 103.5 54.5 102.828 54.5 102C54.5 101.172 55.1716 100.5 56 100.5C56.8284 100.5 57.5 101.172 57.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 102C80.5 102.828 79.8284 103.5 79 103.5C78.1716 103.5 77.5 102.828 77.5 102C77.5 101.172 78.1716 100.5 79 100.5C79.8284 100.5 80.5 101.172 80.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 102C103.5 102.828 102.828 103.5 102 103.5C101.172 103.5 100.5 102.828 100.5 102C100.5 101.172 101.172 100.5 102 100.5C102.828 100.5 103.5 101.172 103.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 102C126.5 102.828 125.828 103.5 125 103.5C124.172 103.5 123.5 102.828 123.5 102C123.5 101.172 124.172 100.5 125 100.5C125.828 100.5 126.5 101.172 126.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 102C149.5 102.828 148.828 103.5 148 103.5C147.172 103.5 146.5 102.828 146.5 102C146.5 101.172 147.172 100.5 148 100.5C148.828 100.5 149.5 101.172 149.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 102C172.5 102.828 171.828 103.5 171 103.5C170.172 103.5 169.5 102.828 169.5 102C169.5 101.172 170.172 100.5 171 100.5C171.828 100.5 172.5 101.172 172.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 102C195.5 102.828 194.828 103.5 194 103.5C193.172 103.5 192.5 102.828 192.5 102C192.5 101.172 193.172 100.5 194 100.5C194.828 100.5 195.5 101.172 195.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 102C218.5 102.828 217.828 103.5 217 103.5C216.172 103.5 215.5 102.828 215.5 102C215.5 101.172 216.172 100.5 217 100.5C217.828 100.5 218.5 101.172 218.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 102C241.5 102.828 240.828 103.5 240 103.5C239.172 103.5 238.5 102.828 238.5 102C238.5 101.172 239.172 100.5 240 100.5C240.828 100.5 241.5 101.172 241.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 102C264.5 102.828 263.828 103.5 263 103.5C262.172 103.5 261.5 102.828 261.5 102C261.5 101.172 262.172 100.5 263 100.5C263.828 100.5 264.5 101.172 264.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 102C287.5 102.828 286.828 103.5 286 103.5C285.172 103.5 284.5 102.828 284.5 102C284.5 101.172 285.172 100.5 286 100.5C286.828 100.5 287.5 101.172 287.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 102C310.5 102.828 309.828 103.5 309 103.5C308.172 103.5 307.5 102.828 307.5 102C307.5 101.172 308.172 100.5 309 100.5C309.828 100.5 310.5 101.172 310.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 102C333.5 102.828 332.828 103.5 332 103.5C331.172 103.5 330.5 102.828 330.5 102C330.5 101.172 331.172 100.5 332 100.5C332.828 100.5 333.5 101.172 333.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 102C356.5 102.828 355.828 103.5 355 103.5C354.172 103.5 353.5 102.828 353.5 102C353.5 101.172 354.172 100.5 355 100.5C355.828 100.5 356.5 101.172 356.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 102C379.5 102.828 378.828 103.5 378 103.5C377.172 103.5 376.5 102.828 376.5 102C376.5 101.172 377.172 100.5 378 100.5C378.828 100.5 379.5 101.172 379.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 102C402.5 102.828 401.828 103.5 401 103.5C400.172 103.5 399.5 102.828 399.5 102C399.5 101.172 400.172 100.5 401 100.5C401.828 100.5 402.5 101.172 402.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 102C425.5 102.828 424.828 103.5 424 103.5C423.172 103.5 422.5 102.828 422.5 102C422.5 101.172 423.172 100.5 424 100.5C424.828 100.5 425.5 101.172 425.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 102C448.5 102.828 447.828 103.5 447 103.5C446.172 103.5 445.5 102.828 445.5 102C445.5 101.172 446.172 100.5 447 100.5C447.828 100.5 448.5 101.172 448.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 102C471.5 102.828 470.828 103.5 470 103.5C469.172 103.5 468.5 102.828 468.5 102C468.5 101.172 469.172 100.5 470 100.5C470.828 100.5 471.5 101.172 471.5 102Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 125C11.5 125.828 10.8284 126.5 10 126.5C9.17157 126.5 8.5 125.828 8.5 125C8.5 124.172 9.17157 123.5 10 123.5C10.8284 123.5 11.5 124.172 11.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 125C34.5 125.828 33.8284 126.5 33 126.5C32.1716 126.5 31.5 125.828 31.5 125C31.5 124.172 32.1716 123.5 33 123.5C33.8284 123.5 34.5 124.172 34.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 125C57.5 125.828 56.8284 126.5 56 126.5C55.1716 126.5 54.5 125.828 54.5 125C54.5 124.172 55.1716 123.5 56 123.5C56.8284 123.5 57.5 124.172 57.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 125C80.5 125.828 79.8284 126.5 79 126.5C78.1716 126.5 77.5 125.828 77.5 125C77.5 124.172 78.1716 123.5 79 123.5C79.8284 123.5 80.5 124.172 80.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 125C103.5 125.828 102.828 126.5 102 126.5C101.172 126.5 100.5 125.828 100.5 125C100.5 124.172 101.172 123.5 102 123.5C102.828 123.5 103.5 124.172 103.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 125C126.5 125.828 125.828 126.5 125 126.5C124.172 126.5 123.5 125.828 123.5 125C123.5 124.172 124.172 123.5 125 123.5C125.828 123.5 126.5 124.172 126.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 125C149.5 125.828 148.828 126.5 148 126.5C147.172 126.5 146.5 125.828 146.5 125C146.5 124.172 147.172 123.5 148 123.5C148.828 123.5 149.5 124.172 149.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 125C172.5 125.828 171.828 126.5 171 126.5C170.172 126.5 169.5 125.828 169.5 125C169.5 124.172 170.172 123.5 171 123.5C171.828 123.5 172.5 124.172 172.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 125C195.5 125.828 194.828 126.5 194 126.5C193.172 126.5 192.5 125.828 192.5 125C192.5 124.172 193.172 123.5 194 123.5C194.828 123.5 195.5 124.172 195.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 125C218.5 125.828 217.828 126.5 217 126.5C216.172 126.5 215.5 125.828 215.5 125C215.5 124.172 216.172 123.5 217 123.5C217.828 123.5 218.5 124.172 218.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 125C241.5 125.828 240.828 126.5 240 126.5C239.172 126.5 238.5 125.828 238.5 125C238.5 124.172 239.172 123.5 240 123.5C240.828 123.5 241.5 124.172 241.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 125C264.5 125.828 263.828 126.5 263 126.5C262.172 126.5 261.5 125.828 261.5 125C261.5 124.172 262.172 123.5 263 123.5C263.828 123.5 264.5 124.172 264.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 125C287.5 125.828 286.828 126.5 286 126.5C285.172 126.5 284.5 125.828 284.5 125C284.5 124.172 285.172 123.5 286 123.5C286.828 123.5 287.5 124.172 287.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 125C310.5 125.828 309.828 126.5 309 126.5C308.172 126.5 307.5 125.828 307.5 125C307.5 124.172 308.172 123.5 309 123.5C309.828 123.5 310.5 124.172 310.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 125C333.5 125.828 332.828 126.5 332 126.5C331.172 126.5 330.5 125.828 330.5 125C330.5 124.172 331.172 123.5 332 123.5C332.828 123.5 333.5 124.172 333.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 125C356.5 125.828 355.828 126.5 355 126.5C354.172 126.5 353.5 125.828 353.5 125C353.5 124.172 354.172 123.5 355 123.5C355.828 123.5 356.5 124.172 356.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 125C379.5 125.828 378.828 126.5 378 126.5C377.172 126.5 376.5 125.828 376.5 125C376.5 124.172 377.172 123.5 378 123.5C378.828 123.5 379.5 124.172 379.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 125C402.5 125.828 401.828 126.5 401 126.5C400.172 126.5 399.5 125.828 399.5 125C399.5 124.172 400.172 123.5 401 123.5C401.828 123.5 402.5 124.172 402.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 125C425.5 125.828 424.828 126.5 424 126.5C423.172 126.5 422.5 125.828 422.5 125C422.5 124.172 423.172 123.5 424 123.5C424.828 123.5 425.5 124.172 425.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 125C448.5 125.828 447.828 126.5 447 126.5C446.172 126.5 445.5 125.828 445.5 125C445.5 124.172 446.172 123.5 447 123.5C447.828 123.5 448.5 124.172 448.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 125C471.5 125.828 470.828 126.5 470 126.5C469.172 126.5 468.5 125.828 468.5 125C468.5 124.172 469.172 123.5 470 123.5C470.828 123.5 471.5 124.172 471.5 125Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 148C11.5 148.828 10.8284 149.5 10 149.5C9.17157 149.5 8.5 148.828 8.5 148C8.5 147.172 9.17157 146.5 10 146.5C10.8284 146.5 11.5 147.172 11.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 148C34.5 148.828 33.8284 149.5 33 149.5C32.1716 149.5 31.5 148.828 31.5 148C31.5 147.172 32.1716 146.5 33 146.5C33.8284 146.5 34.5 147.172 34.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 148C57.5 148.828 56.8284 149.5 56 149.5C55.1716 149.5 54.5 148.828 54.5 148C54.5 147.172 55.1716 146.5 56 146.5C56.8284 146.5 57.5 147.172 57.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 148C80.5 148.828 79.8284 149.5 79 149.5C78.1716 149.5 77.5 148.828 77.5 148C77.5 147.172 78.1716 146.5 79 146.5C79.8284 146.5 80.5 147.172 80.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 148C103.5 148.828 102.828 149.5 102 149.5C101.172 149.5 100.5 148.828 100.5 148C100.5 147.172 101.172 146.5 102 146.5C102.828 146.5 103.5 147.172 103.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 148C126.5 148.828 125.828 149.5 125 149.5C124.172 149.5 123.5 148.828 123.5 148C123.5 147.172 124.172 146.5 125 146.5C125.828 146.5 126.5 147.172 126.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 148C149.5 148.828 148.828 149.5 148 149.5C147.172 149.5 146.5 148.828 146.5 148C146.5 147.172 147.172 146.5 148 146.5C148.828 146.5 149.5 147.172 149.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 148C172.5 148.828 171.828 149.5 171 149.5C170.172 149.5 169.5 148.828 169.5 148C169.5 147.172 170.172 146.5 171 146.5C171.828 146.5 172.5 147.172 172.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 148C195.5 148.828 194.828 149.5 194 149.5C193.172 149.5 192.5 148.828 192.5 148C192.5 147.172 193.172 146.5 194 146.5C194.828 146.5 195.5 147.172 195.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 148C218.5 148.828 217.828 149.5 217 149.5C216.172 149.5 215.5 148.828 215.5 148C215.5 147.172 216.172 146.5 217 146.5C217.828 146.5 218.5 147.172 218.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 148C241.5 148.828 240.828 149.5 240 149.5C239.172 149.5 238.5 148.828 238.5 148C238.5 147.172 239.172 146.5 240 146.5C240.828 146.5 241.5 147.172 241.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 148C264.5 148.828 263.828 149.5 263 149.5C262.172 149.5 261.5 148.828 261.5 148C261.5 147.172 262.172 146.5 263 146.5C263.828 146.5 264.5 147.172 264.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 148C287.5 148.828 286.828 149.5 286 149.5C285.172 149.5 284.5 148.828 284.5 148C284.5 147.172 285.172 146.5 286 146.5C286.828 146.5 287.5 147.172 287.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 148C310.5 148.828 309.828 149.5 309 149.5C308.172 149.5 307.5 148.828 307.5 148C307.5 147.172 308.172 146.5 309 146.5C309.828 146.5 310.5 147.172 310.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 148C333.5 148.828 332.828 149.5 332 149.5C331.172 149.5 330.5 148.828 330.5 148C330.5 147.172 331.172 146.5 332 146.5C332.828 146.5 333.5 147.172 333.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 148C356.5 148.828 355.828 149.5 355 149.5C354.172 149.5 353.5 148.828 353.5 148C353.5 147.172 354.172 146.5 355 146.5C355.828 146.5 356.5 147.172 356.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 148C379.5 148.828 378.828 149.5 378 149.5C377.172 149.5 376.5 148.828 376.5 148C376.5 147.172 377.172 146.5 378 146.5C378.828 146.5 379.5 147.172 379.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 148C402.5 148.828 401.828 149.5 401 149.5C400.172 149.5 399.5 148.828 399.5 148C399.5 147.172 400.172 146.5 401 146.5C401.828 146.5 402.5 147.172 402.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 148C425.5 148.828 424.828 149.5 424 149.5C423.172 149.5 422.5 148.828 422.5 148C422.5 147.172 423.172 146.5 424 146.5C424.828 146.5 425.5 147.172 425.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 148C448.5 148.828 447.828 149.5 447 149.5C446.172 149.5 445.5 148.828 445.5 148C445.5 147.172 446.172 146.5 447 146.5C447.828 146.5 448.5 147.172 448.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 148C471.5 148.828 470.828 149.5 470 149.5C469.172 149.5 468.5 148.828 468.5 148C468.5 147.172 469.172 146.5 470 146.5C470.828 146.5 471.5 147.172 471.5 148Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 171C11.5 171.828 10.8284 172.5 10 172.5C9.17157 172.5 8.5 171.828 8.5 171C8.5 170.172 9.17157 169.5 10 169.5C10.8284 169.5 11.5 170.172 11.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 171C34.5 171.828 33.8284 172.5 33 172.5C32.1716 172.5 31.5 171.828 31.5 171C31.5 170.172 32.1716 169.5 33 169.5C33.8284 169.5 34.5 170.172 34.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 171C57.5 171.828 56.8284 172.5 56 172.5C55.1716 172.5 54.5 171.828 54.5 171C54.5 170.172 55.1716 169.5 56 169.5C56.8284 169.5 57.5 170.172 57.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 171C80.5 171.828 79.8284 172.5 79 172.5C78.1716 172.5 77.5 171.828 77.5 171C77.5 170.172 78.1716 169.5 79 169.5C79.8284 169.5 80.5 170.172 80.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 171C103.5 171.828 102.828 172.5 102 172.5C101.172 172.5 100.5 171.828 100.5 171C100.5 170.172 101.172 169.5 102 169.5C102.828 169.5 103.5 170.172 103.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 171C126.5 171.828 125.828 172.5 125 172.5C124.172 172.5 123.5 171.828 123.5 171C123.5 170.172 124.172 169.5 125 169.5C125.828 169.5 126.5 170.172 126.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 171C149.5 171.828 148.828 172.5 148 172.5C147.172 172.5 146.5 171.828 146.5 171C146.5 170.172 147.172 169.5 148 169.5C148.828 169.5 149.5 170.172 149.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 171C172.5 171.828 171.828 172.5 171 172.5C170.172 172.5 169.5 171.828 169.5 171C169.5 170.172 170.172 169.5 171 169.5C171.828 169.5 172.5 170.172 172.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 171C195.5 171.828 194.828 172.5 194 172.5C193.172 172.5 192.5 171.828 192.5 171C192.5 170.172 193.172 169.5 194 169.5C194.828 169.5 195.5 170.172 195.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 171C218.5 171.828 217.828 172.5 217 172.5C216.172 172.5 215.5 171.828 215.5 171C215.5 170.172 216.172 169.5 217 169.5C217.828 169.5 218.5 170.172 218.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 171C241.5 171.828 240.828 172.5 240 172.5C239.172 172.5 238.5 171.828 238.5 171C238.5 170.172 239.172 169.5 240 169.5C240.828 169.5 241.5 170.172 241.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 171C264.5 171.828 263.828 172.5 263 172.5C262.172 172.5 261.5 171.828 261.5 171C261.5 170.172 262.172 169.5 263 169.5C263.828 169.5 264.5 170.172 264.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 171C287.5 171.828 286.828 172.5 286 172.5C285.172 172.5 284.5 171.828 284.5 171C284.5 170.172 285.172 169.5 286 169.5C286.828 169.5 287.5 170.172 287.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 171C310.5 171.828 309.828 172.5 309 172.5C308.172 172.5 307.5 171.828 307.5 171C307.5 170.172 308.172 169.5 309 169.5C309.828 169.5 310.5 170.172 310.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 171C333.5 171.828 332.828 172.5 332 172.5C331.172 172.5 330.5 171.828 330.5 171C330.5 170.172 331.172 169.5 332 169.5C332.828 169.5 333.5 170.172 333.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 171C356.5 171.828 355.828 172.5 355 172.5C354.172 172.5 353.5 171.828 353.5 171C353.5 170.172 354.172 169.5 355 169.5C355.828 169.5 356.5 170.172 356.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 171C379.5 171.828 378.828 172.5 378 172.5C377.172 172.5 376.5 171.828 376.5 171C376.5 170.172 377.172 169.5 378 169.5C378.828 169.5 379.5 170.172 379.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 171C402.5 171.828 401.828 172.5 401 172.5C400.172 172.5 399.5 171.828 399.5 171C399.5 170.172 400.172 169.5 401 169.5C401.828 169.5 402.5 170.172 402.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 171C425.5 171.828 424.828 172.5 424 172.5C423.172 172.5 422.5 171.828 422.5 171C422.5 170.172 423.172 169.5 424 169.5C424.828 169.5 425.5 170.172 425.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 171C448.5 171.828 447.828 172.5 447 172.5C446.172 172.5 445.5 171.828 445.5 171C445.5 170.172 446.172 169.5 447 169.5C447.828 169.5 448.5 170.172 448.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 171C471.5 171.828 470.828 172.5 470 172.5C469.172 172.5 468.5 171.828 468.5 171C468.5 170.172 469.172 169.5 470 169.5C470.828 169.5 471.5 170.172 471.5 171Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 194C11.5 194.828 10.8284 195.5 10 195.5C9.17157 195.5 8.5 194.828 8.5 194C8.5 193.172 9.17157 192.5 10 192.5C10.8284 192.5 11.5 193.172 11.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 194C34.5 194.828 33.8284 195.5 33 195.5C32.1716 195.5 31.5 194.828 31.5 194C31.5 193.172 32.1716 192.5 33 192.5C33.8284 192.5 34.5 193.172 34.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 194C57.5 194.828 56.8284 195.5 56 195.5C55.1716 195.5 54.5 194.828 54.5 194C54.5 193.172 55.1716 192.5 56 192.5C56.8284 192.5 57.5 193.172 57.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 194C80.5 194.828 79.8284 195.5 79 195.5C78.1716 195.5 77.5 194.828 77.5 194C77.5 193.172 78.1716 192.5 79 192.5C79.8284 192.5 80.5 193.172 80.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 194C103.5 194.828 102.828 195.5 102 195.5C101.172 195.5 100.5 194.828 100.5 194C100.5 193.172 101.172 192.5 102 192.5C102.828 192.5 103.5 193.172 103.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 194C126.5 194.828 125.828 195.5 125 195.5C124.172 195.5 123.5 194.828 123.5 194C123.5 193.172 124.172 192.5 125 192.5C125.828 192.5 126.5 193.172 126.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 194C149.5 194.828 148.828 195.5 148 195.5C147.172 195.5 146.5 194.828 146.5 194C146.5 193.172 147.172 192.5 148 192.5C148.828 192.5 149.5 193.172 149.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 194C172.5 194.828 171.828 195.5 171 195.5C170.172 195.5 169.5 194.828 169.5 194C169.5 193.172 170.172 192.5 171 192.5C171.828 192.5 172.5 193.172 172.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 194C195.5 194.828 194.828 195.5 194 195.5C193.172 195.5 192.5 194.828 192.5 194C192.5 193.172 193.172 192.5 194 192.5C194.828 192.5 195.5 193.172 195.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 194C218.5 194.828 217.828 195.5 217 195.5C216.172 195.5 215.5 194.828 215.5 194C215.5 193.172 216.172 192.5 217 192.5C217.828 192.5 218.5 193.172 218.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 194C241.5 194.828 240.828 195.5 240 195.5C239.172 195.5 238.5 194.828 238.5 194C238.5 193.172 239.172 192.5 240 192.5C240.828 192.5 241.5 193.172 241.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 194C264.5 194.828 263.828 195.5 263 195.5C262.172 195.5 261.5 194.828 261.5 194C261.5 193.172 262.172 192.5 263 192.5C263.828 192.5 264.5 193.172 264.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 194C287.5 194.828 286.828 195.5 286 195.5C285.172 195.5 284.5 194.828 284.5 194C284.5 193.172 285.172 192.5 286 192.5C286.828 192.5 287.5 193.172 287.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 194C310.5 194.828 309.828 195.5 309 195.5C308.172 195.5 307.5 194.828 307.5 194C307.5 193.172 308.172 192.5 309 192.5C309.828 192.5 310.5 193.172 310.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 194C333.5 194.828 332.828 195.5 332 195.5C331.172 195.5 330.5 194.828 330.5 194C330.5 193.172 331.172 192.5 332 192.5C332.828 192.5 333.5 193.172 333.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 194C356.5 194.828 355.828 195.5 355 195.5C354.172 195.5 353.5 194.828 353.5 194C353.5 193.172 354.172 192.5 355 192.5C355.828 192.5 356.5 193.172 356.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 194C379.5 194.828 378.828 195.5 378 195.5C377.172 195.5 376.5 194.828 376.5 194C376.5 193.172 377.172 192.5 378 192.5C378.828 192.5 379.5 193.172 379.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 194C402.5 194.828 401.828 195.5 401 195.5C400.172 195.5 399.5 194.828 399.5 194C399.5 193.172 400.172 192.5 401 192.5C401.828 192.5 402.5 193.172 402.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 194C425.5 194.828 424.828 195.5 424 195.5C423.172 195.5 422.5 194.828 422.5 194C422.5 193.172 423.172 192.5 424 192.5C424.828 192.5 425.5 193.172 425.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 194C448.5 194.828 447.828 195.5 447 195.5C446.172 195.5 445.5 194.828 445.5 194C445.5 193.172 446.172 192.5 447 192.5C447.828 192.5 448.5 193.172 448.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 194C471.5 194.828 470.828 195.5 470 195.5C469.172 195.5 468.5 194.828 468.5 194C468.5 193.172 469.172 192.5 470 192.5C470.828 192.5 471.5 193.172 471.5 194Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 217C11.5 217.828 10.8284 218.5 10 218.5C9.17157 218.5 8.5 217.828 8.5 217C8.5 216.172 9.17157 215.5 10 215.5C10.8284 215.5 11.5 216.172 11.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 217C34.5 217.828 33.8284 218.5 33 218.5C32.1716 218.5 31.5 217.828 31.5 217C31.5 216.172 32.1716 215.5 33 215.5C33.8284 215.5 34.5 216.172 34.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 217C57.5 217.828 56.8284 218.5 56 218.5C55.1716 218.5 54.5 217.828 54.5 217C54.5 216.172 55.1716 215.5 56 215.5C56.8284 215.5 57.5 216.172 57.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 217C80.5 217.828 79.8284 218.5 79 218.5C78.1716 218.5 77.5 217.828 77.5 217C77.5 216.172 78.1716 215.5 79 215.5C79.8284 215.5 80.5 216.172 80.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 217C103.5 217.828 102.828 218.5 102 218.5C101.172 218.5 100.5 217.828 100.5 217C100.5 216.172 101.172 215.5 102 215.5C102.828 215.5 103.5 216.172 103.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 217C126.5 217.828 125.828 218.5 125 218.5C124.172 218.5 123.5 217.828 123.5 217C123.5 216.172 124.172 215.5 125 215.5C125.828 215.5 126.5 216.172 126.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 217C149.5 217.828 148.828 218.5 148 218.5C147.172 218.5 146.5 217.828 146.5 217C146.5 216.172 147.172 215.5 148 215.5C148.828 215.5 149.5 216.172 149.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 217C172.5 217.828 171.828 218.5 171 218.5C170.172 218.5 169.5 217.828 169.5 217C169.5 216.172 170.172 215.5 171 215.5C171.828 215.5 172.5 216.172 172.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 217C195.5 217.828 194.828 218.5 194 218.5C193.172 218.5 192.5 217.828 192.5 217C192.5 216.172 193.172 215.5 194 215.5C194.828 215.5 195.5 216.172 195.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 217C218.5 217.828 217.828 218.5 217 218.5C216.172 218.5 215.5 217.828 215.5 217C215.5 216.172 216.172 215.5 217 215.5C217.828 215.5 218.5 216.172 218.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 217C241.5 217.828 240.828 218.5 240 218.5C239.172 218.5 238.5 217.828 238.5 217C238.5 216.172 239.172 215.5 240 215.5C240.828 215.5 241.5 216.172 241.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 217C264.5 217.828 263.828 218.5 263 218.5C262.172 218.5 261.5 217.828 261.5 217C261.5 216.172 262.172 215.5 263 215.5C263.828 215.5 264.5 216.172 264.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 217C287.5 217.828 286.828 218.5 286 218.5C285.172 218.5 284.5 217.828 284.5 217C284.5 216.172 285.172 215.5 286 215.5C286.828 215.5 287.5 216.172 287.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 217C310.5 217.828 309.828 218.5 309 218.5C308.172 218.5 307.5 217.828 307.5 217C307.5 216.172 308.172 215.5 309 215.5C309.828 215.5 310.5 216.172 310.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 217C333.5 217.828 332.828 218.5 332 218.5C331.172 218.5 330.5 217.828 330.5 217C330.5 216.172 331.172 215.5 332 215.5C332.828 215.5 333.5 216.172 333.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 217C356.5 217.828 355.828 218.5 355 218.5C354.172 218.5 353.5 217.828 353.5 217C353.5 216.172 354.172 215.5 355 215.5C355.828 215.5 356.5 216.172 356.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 217C379.5 217.828 378.828 218.5 378 218.5C377.172 218.5 376.5 217.828 376.5 217C376.5 216.172 377.172 215.5 378 215.5C378.828 215.5 379.5 216.172 379.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 217C402.5 217.828 401.828 218.5 401 218.5C400.172 218.5 399.5 217.828 399.5 217C399.5 216.172 400.172 215.5 401 215.5C401.828 215.5 402.5 216.172 402.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 217C425.5 217.828 424.828 218.5 424 218.5C423.172 218.5 422.5 217.828 422.5 217C422.5 216.172 423.172 215.5 424 215.5C424.828 215.5 425.5 216.172 425.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 217C448.5 217.828 447.828 218.5 447 218.5C446.172 218.5 445.5 217.828 445.5 217C445.5 216.172 446.172 215.5 447 215.5C447.828 215.5 448.5 216.172 448.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 217C471.5 217.828 470.828 218.5 470 218.5C469.172 218.5 468.5 217.828 468.5 217C468.5 216.172 469.172 215.5 470 215.5C470.828 215.5 471.5 216.172 471.5 217Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 240C11.5 240.828 10.8284 241.5 10 241.5C9.17157 241.5 8.5 240.828 8.5 240C8.5 239.172 9.17157 238.5 10 238.5C10.8284 238.5 11.5 239.172 11.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 240C34.5 240.828 33.8284 241.5 33 241.5C32.1716 241.5 31.5 240.828 31.5 240C31.5 239.172 32.1716 238.5 33 238.5C33.8284 238.5 34.5 239.172 34.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 240C57.5 240.828 56.8284 241.5 56 241.5C55.1716 241.5 54.5 240.828 54.5 240C54.5 239.172 55.1716 238.5 56 238.5C56.8284 238.5 57.5 239.172 57.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 240C80.5 240.828 79.8284 241.5 79 241.5C78.1716 241.5 77.5 240.828 77.5 240C77.5 239.172 78.1716 238.5 79 238.5C79.8284 238.5 80.5 239.172 80.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 240C103.5 240.828 102.828 241.5 102 241.5C101.172 241.5 100.5 240.828 100.5 240C100.5 239.172 101.172 238.5 102 238.5C102.828 238.5 103.5 239.172 103.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 240C126.5 240.828 125.828 241.5 125 241.5C124.172 241.5 123.5 240.828 123.5 240C123.5 239.172 124.172 238.5 125 238.5C125.828 238.5 126.5 239.172 126.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 240C149.5 240.828 148.828 241.5 148 241.5C147.172 241.5 146.5 240.828 146.5 240C146.5 239.172 147.172 238.5 148 238.5C148.828 238.5 149.5 239.172 149.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 240C172.5 240.828 171.828 241.5 171 241.5C170.172 241.5 169.5 240.828 169.5 240C169.5 239.172 170.172 238.5 171 238.5C171.828 238.5 172.5 239.172 172.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 240C195.5 240.828 194.828 241.5 194 241.5C193.172 241.5 192.5 240.828 192.5 240C192.5 239.172 193.172 238.5 194 238.5C194.828 238.5 195.5 239.172 195.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 240C218.5 240.828 217.828 241.5 217 241.5C216.172 241.5 215.5 240.828 215.5 240C215.5 239.172 216.172 238.5 217 238.5C217.828 238.5 218.5 239.172 218.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 240C241.5 240.828 240.828 241.5 240 241.5C239.172 241.5 238.5 240.828 238.5 240C238.5 239.172 239.172 238.5 240 238.5C240.828 238.5 241.5 239.172 241.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 240C264.5 240.828 263.828 241.5 263 241.5C262.172 241.5 261.5 240.828 261.5 240C261.5 239.172 262.172 238.5 263 238.5C263.828 238.5 264.5 239.172 264.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 240C287.5 240.828 286.828 241.5 286 241.5C285.172 241.5 284.5 240.828 284.5 240C284.5 239.172 285.172 238.5 286 238.5C286.828 238.5 287.5 239.172 287.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 240C310.5 240.828 309.828 241.5 309 241.5C308.172 241.5 307.5 240.828 307.5 240C307.5 239.172 308.172 238.5 309 238.5C309.828 238.5 310.5 239.172 310.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 240C333.5 240.828 332.828 241.5 332 241.5C331.172 241.5 330.5 240.828 330.5 240C330.5 239.172 331.172 238.5 332 238.5C332.828 238.5 333.5 239.172 333.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 240C356.5 240.828 355.828 241.5 355 241.5C354.172 241.5 353.5 240.828 353.5 240C353.5 239.172 354.172 238.5 355 238.5C355.828 238.5 356.5 239.172 356.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 240C379.5 240.828 378.828 241.5 378 241.5C377.172 241.5 376.5 240.828 376.5 240C376.5 239.172 377.172 238.5 378 238.5C378.828 238.5 379.5 239.172 379.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 240C402.5 240.828 401.828 241.5 401 241.5C400.172 241.5 399.5 240.828 399.5 240C399.5 239.172 400.172 238.5 401 238.5C401.828 238.5 402.5 239.172 402.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 240C425.5 240.828 424.828 241.5 424 241.5C423.172 241.5 422.5 240.828 422.5 240C422.5 239.172 423.172 238.5 424 238.5C424.828 238.5 425.5 239.172 425.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 240C448.5 240.828 447.828 241.5 447 241.5C446.172 241.5 445.5 240.828 445.5 240C445.5 239.172 446.172 238.5 447 238.5C447.828 238.5 448.5 239.172 448.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 240C471.5 240.828 470.828 241.5 470 241.5C469.172 241.5 468.5 240.828 468.5 240C468.5 239.172 469.172 238.5 470 238.5C470.828 238.5 471.5 239.172 471.5 240Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 263C11.5 263.828 10.8284 264.5 10 264.5C9.17157 264.5 8.5 263.828 8.5 263C8.5 262.172 9.17157 261.5 10 261.5C10.8284 261.5 11.5 262.172 11.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 263C34.5 263.828 33.8284 264.5 33 264.5C32.1716 264.5 31.5 263.828 31.5 263C31.5 262.172 32.1716 261.5 33 261.5C33.8284 261.5 34.5 262.172 34.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 263C57.5 263.828 56.8284 264.5 56 264.5C55.1716 264.5 54.5 263.828 54.5 263C54.5 262.172 55.1716 261.5 56 261.5C56.8284 261.5 57.5 262.172 57.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 263C80.5 263.828 79.8284 264.5 79 264.5C78.1716 264.5 77.5 263.828 77.5 263C77.5 262.172 78.1716 261.5 79 261.5C79.8284 261.5 80.5 262.172 80.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 263C103.5 263.828 102.828 264.5 102 264.5C101.172 264.5 100.5 263.828 100.5 263C100.5 262.172 101.172 261.5 102 261.5C102.828 261.5 103.5 262.172 103.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 263C126.5 263.828 125.828 264.5 125 264.5C124.172 264.5 123.5 263.828 123.5 263C123.5 262.172 124.172 261.5 125 261.5C125.828 261.5 126.5 262.172 126.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 263C149.5 263.828 148.828 264.5 148 264.5C147.172 264.5 146.5 263.828 146.5 263C146.5 262.172 147.172 261.5 148 261.5C148.828 261.5 149.5 262.172 149.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 263C172.5 263.828 171.828 264.5 171 264.5C170.172 264.5 169.5 263.828 169.5 263C169.5 262.172 170.172 261.5 171 261.5C171.828 261.5 172.5 262.172 172.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 263C195.5 263.828 194.828 264.5 194 264.5C193.172 264.5 192.5 263.828 192.5 263C192.5 262.172 193.172 261.5 194 261.5C194.828 261.5 195.5 262.172 195.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 263C218.5 263.828 217.828 264.5 217 264.5C216.172 264.5 215.5 263.828 215.5 263C215.5 262.172 216.172 261.5 217 261.5C217.828 261.5 218.5 262.172 218.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 263C241.5 263.828 240.828 264.5 240 264.5C239.172 264.5 238.5 263.828 238.5 263C238.5 262.172 239.172 261.5 240 261.5C240.828 261.5 241.5 262.172 241.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 263C264.5 263.828 263.828 264.5 263 264.5C262.172 264.5 261.5 263.828 261.5 263C261.5 262.172 262.172 261.5 263 261.5C263.828 261.5 264.5 262.172 264.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 263C287.5 263.828 286.828 264.5 286 264.5C285.172 264.5 284.5 263.828 284.5 263C284.5 262.172 285.172 261.5 286 261.5C286.828 261.5 287.5 262.172 287.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 263C310.5 263.828 309.828 264.5 309 264.5C308.172 264.5 307.5 263.828 307.5 263C307.5 262.172 308.172 261.5 309 261.5C309.828 261.5 310.5 262.172 310.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 263C333.5 263.828 332.828 264.5 332 264.5C331.172 264.5 330.5 263.828 330.5 263C330.5 262.172 331.172 261.5 332 261.5C332.828 261.5 333.5 262.172 333.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 263C356.5 263.828 355.828 264.5 355 264.5C354.172 264.5 353.5 263.828 353.5 263C353.5 262.172 354.172 261.5 355 261.5C355.828 261.5 356.5 262.172 356.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 263C379.5 263.828 378.828 264.5 378 264.5C377.172 264.5 376.5 263.828 376.5 263C376.5 262.172 377.172 261.5 378 261.5C378.828 261.5 379.5 262.172 379.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 263C402.5 263.828 401.828 264.5 401 264.5C400.172 264.5 399.5 263.828 399.5 263C399.5 262.172 400.172 261.5 401 261.5C401.828 261.5 402.5 262.172 402.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 263C425.5 263.828 424.828 264.5 424 264.5C423.172 264.5 422.5 263.828 422.5 263C422.5 262.172 423.172 261.5 424 261.5C424.828 261.5 425.5 262.172 425.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 263C448.5 263.828 447.828 264.5 447 264.5C446.172 264.5 445.5 263.828 445.5 263C445.5 262.172 446.172 261.5 447 261.5C447.828 261.5 448.5 262.172 448.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 263C471.5 263.828 470.828 264.5 470 264.5C469.172 264.5 468.5 263.828 468.5 263C468.5 262.172 469.172 261.5 470 261.5C470.828 261.5 471.5 262.172 471.5 263Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 286C11.5 286.828 10.8284 287.5 10 287.5C9.17157 287.5 8.5 286.828 8.5 286C8.5 285.172 9.17157 284.5 10 284.5C10.8284 284.5 11.5 285.172 11.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 286C34.5 286.828 33.8284 287.5 33 287.5C32.1716 287.5 31.5 286.828 31.5 286C31.5 285.172 32.1716 284.5 33 284.5C33.8284 284.5 34.5 285.172 34.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 286C57.5 286.828 56.8284 287.5 56 287.5C55.1716 287.5 54.5 286.828 54.5 286C54.5 285.172 55.1716 284.5 56 284.5C56.8284 284.5 57.5 285.172 57.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 286C80.5 286.828 79.8284 287.5 79 287.5C78.1716 287.5 77.5 286.828 77.5 286C77.5 285.172 78.1716 284.5 79 284.5C79.8284 284.5 80.5 285.172 80.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 286C103.5 286.828 102.828 287.5 102 287.5C101.172 287.5 100.5 286.828 100.5 286C100.5 285.172 101.172 284.5 102 284.5C102.828 284.5 103.5 285.172 103.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 286C126.5 286.828 125.828 287.5 125 287.5C124.172 287.5 123.5 286.828 123.5 286C123.5 285.172 124.172 284.5 125 284.5C125.828 284.5 126.5 285.172 126.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 286C149.5 286.828 148.828 287.5 148 287.5C147.172 287.5 146.5 286.828 146.5 286C146.5 285.172 147.172 284.5 148 284.5C148.828 284.5 149.5 285.172 149.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 286C172.5 286.828 171.828 287.5 171 287.5C170.172 287.5 169.5 286.828 169.5 286C169.5 285.172 170.172 284.5 171 284.5C171.828 284.5 172.5 285.172 172.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 286C195.5 286.828 194.828 287.5 194 287.5C193.172 287.5 192.5 286.828 192.5 286C192.5 285.172 193.172 284.5 194 284.5C194.828 284.5 195.5 285.172 195.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 286C218.5 286.828 217.828 287.5 217 287.5C216.172 287.5 215.5 286.828 215.5 286C215.5 285.172 216.172 284.5 217 284.5C217.828 284.5 218.5 285.172 218.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 286C241.5 286.828 240.828 287.5 240 287.5C239.172 287.5 238.5 286.828 238.5 286C238.5 285.172 239.172 284.5 240 284.5C240.828 284.5 241.5 285.172 241.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 286C264.5 286.828 263.828 287.5 263 287.5C262.172 287.5 261.5 286.828 261.5 286C261.5 285.172 262.172 284.5 263 284.5C263.828 284.5 264.5 285.172 264.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 286C287.5 286.828 286.828 287.5 286 287.5C285.172 287.5 284.5 286.828 284.5 286C284.5 285.172 285.172 284.5 286 284.5C286.828 284.5 287.5 285.172 287.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 286C310.5 286.828 309.828 287.5 309 287.5C308.172 287.5 307.5 286.828 307.5 286C307.5 285.172 308.172 284.5 309 284.5C309.828 284.5 310.5 285.172 310.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 286C333.5 286.828 332.828 287.5 332 287.5C331.172 287.5 330.5 286.828 330.5 286C330.5 285.172 331.172 284.5 332 284.5C332.828 284.5 333.5 285.172 333.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 286C356.5 286.828 355.828 287.5 355 287.5C354.172 287.5 353.5 286.828 353.5 286C353.5 285.172 354.172 284.5 355 284.5C355.828 284.5 356.5 285.172 356.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 286C379.5 286.828 378.828 287.5 378 287.5C377.172 287.5 376.5 286.828 376.5 286C376.5 285.172 377.172 284.5 378 284.5C378.828 284.5 379.5 285.172 379.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 286C402.5 286.828 401.828 287.5 401 287.5C400.172 287.5 399.5 286.828 399.5 286C399.5 285.172 400.172 284.5 401 284.5C401.828 284.5 402.5 285.172 402.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 286C425.5 286.828 424.828 287.5 424 287.5C423.172 287.5 422.5 286.828 422.5 286C422.5 285.172 423.172 284.5 424 284.5C424.828 284.5 425.5 285.172 425.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 286C448.5 286.828 447.828 287.5 447 287.5C446.172 287.5 445.5 286.828 445.5 286C445.5 285.172 446.172 284.5 447 284.5C447.828 284.5 448.5 285.172 448.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 286C471.5 286.828 470.828 287.5 470 287.5C469.172 287.5 468.5 286.828 468.5 286C468.5 285.172 469.172 284.5 470 284.5C470.828 284.5 471.5 285.172 471.5 286Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 309C11.5 309.828 10.8284 310.5 10 310.5C9.17157 310.5 8.5 309.828 8.5 309C8.5 308.172 9.17157 307.5 10 307.5C10.8284 307.5 11.5 308.172 11.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 309C34.5 309.828 33.8284 310.5 33 310.5C32.1716 310.5 31.5 309.828 31.5 309C31.5 308.172 32.1716 307.5 33 307.5C33.8284 307.5 34.5 308.172 34.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 309C57.5 309.828 56.8284 310.5 56 310.5C55.1716 310.5 54.5 309.828 54.5 309C54.5 308.172 55.1716 307.5 56 307.5C56.8284 307.5 57.5 308.172 57.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 309C80.5 309.828 79.8284 310.5 79 310.5C78.1716 310.5 77.5 309.828 77.5 309C77.5 308.172 78.1716 307.5 79 307.5C79.8284 307.5 80.5 308.172 80.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 309C103.5 309.828 102.828 310.5 102 310.5C101.172 310.5 100.5 309.828 100.5 309C100.5 308.172 101.172 307.5 102 307.5C102.828 307.5 103.5 308.172 103.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 309C126.5 309.828 125.828 310.5 125 310.5C124.172 310.5 123.5 309.828 123.5 309C123.5 308.172 124.172 307.5 125 307.5C125.828 307.5 126.5 308.172 126.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 309C149.5 309.828 148.828 310.5 148 310.5C147.172 310.5 146.5 309.828 146.5 309C146.5 308.172 147.172 307.5 148 307.5C148.828 307.5 149.5 308.172 149.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 309C172.5 309.828 171.828 310.5 171 310.5C170.172 310.5 169.5 309.828 169.5 309C169.5 308.172 170.172 307.5 171 307.5C171.828 307.5 172.5 308.172 172.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 309C195.5 309.828 194.828 310.5 194 310.5C193.172 310.5 192.5 309.828 192.5 309C192.5 308.172 193.172 307.5 194 307.5C194.828 307.5 195.5 308.172 195.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 309C218.5 309.828 217.828 310.5 217 310.5C216.172 310.5 215.5 309.828 215.5 309C215.5 308.172 216.172 307.5 217 307.5C217.828 307.5 218.5 308.172 218.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 309C241.5 309.828 240.828 310.5 240 310.5C239.172 310.5 238.5 309.828 238.5 309C238.5 308.172 239.172 307.5 240 307.5C240.828 307.5 241.5 308.172 241.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 309C264.5 309.828 263.828 310.5 263 310.5C262.172 310.5 261.5 309.828 261.5 309C261.5 308.172 262.172 307.5 263 307.5C263.828 307.5 264.5 308.172 264.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 309C287.5 309.828 286.828 310.5 286 310.5C285.172 310.5 284.5 309.828 284.5 309C284.5 308.172 285.172 307.5 286 307.5C286.828 307.5 287.5 308.172 287.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 309C310.5 309.828 309.828 310.5 309 310.5C308.172 310.5 307.5 309.828 307.5 309C307.5 308.172 308.172 307.5 309 307.5C309.828 307.5 310.5 308.172 310.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 309C333.5 309.828 332.828 310.5 332 310.5C331.172 310.5 330.5 309.828 330.5 309C330.5 308.172 331.172 307.5 332 307.5C332.828 307.5 333.5 308.172 333.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 309C356.5 309.828 355.828 310.5 355 310.5C354.172 310.5 353.5 309.828 353.5 309C353.5 308.172 354.172 307.5 355 307.5C355.828 307.5 356.5 308.172 356.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 309C379.5 309.828 378.828 310.5 378 310.5C377.172 310.5 376.5 309.828 376.5 309C376.5 308.172 377.172 307.5 378 307.5C378.828 307.5 379.5 308.172 379.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 309C402.5 309.828 401.828 310.5 401 310.5C400.172 310.5 399.5 309.828 399.5 309C399.5 308.172 400.172 307.5 401 307.5C401.828 307.5 402.5 308.172 402.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 309C425.5 309.828 424.828 310.5 424 310.5C423.172 310.5 422.5 309.828 422.5 309C422.5 308.172 423.172 307.5 424 307.5C424.828 307.5 425.5 308.172 425.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 309C448.5 309.828 447.828 310.5 447 310.5C446.172 310.5 445.5 309.828 445.5 309C445.5 308.172 446.172 307.5 447 307.5C447.828 307.5 448.5 308.172 448.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 309C471.5 309.828 470.828 310.5 470 310.5C469.172 310.5 468.5 309.828 468.5 309C468.5 308.172 469.172 307.5 470 307.5C470.828 307.5 471.5 308.172 471.5 309Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 332C11.5 332.828 10.8284 333.5 10 333.5C9.17157 333.5 8.5 332.828 8.5 332C8.5 331.172 9.17157 330.5 10 330.5C10.8284 330.5 11.5 331.172 11.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 332C34.5 332.828 33.8284 333.5 33 333.5C32.1716 333.5 31.5 332.828 31.5 332C31.5 331.172 32.1716 330.5 33 330.5C33.8284 330.5 34.5 331.172 34.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 332C57.5 332.828 56.8284 333.5 56 333.5C55.1716 333.5 54.5 332.828 54.5 332C54.5 331.172 55.1716 330.5 56 330.5C56.8284 330.5 57.5 331.172 57.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 332C80.5 332.828 79.8284 333.5 79 333.5C78.1716 333.5 77.5 332.828 77.5 332C77.5 331.172 78.1716 330.5 79 330.5C79.8284 330.5 80.5 331.172 80.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 332C103.5 332.828 102.828 333.5 102 333.5C101.172 333.5 100.5 332.828 100.5 332C100.5 331.172 101.172 330.5 102 330.5C102.828 330.5 103.5 331.172 103.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 332C126.5 332.828 125.828 333.5 125 333.5C124.172 333.5 123.5 332.828 123.5 332C123.5 331.172 124.172 330.5 125 330.5C125.828 330.5 126.5 331.172 126.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 332C149.5 332.828 148.828 333.5 148 333.5C147.172 333.5 146.5 332.828 146.5 332C146.5 331.172 147.172 330.5 148 330.5C148.828 330.5 149.5 331.172 149.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 332C172.5 332.828 171.828 333.5 171 333.5C170.172 333.5 169.5 332.828 169.5 332C169.5 331.172 170.172 330.5 171 330.5C171.828 330.5 172.5 331.172 172.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 332C195.5 332.828 194.828 333.5 194 333.5C193.172 333.5 192.5 332.828 192.5 332C192.5 331.172 193.172 330.5 194 330.5C194.828 330.5 195.5 331.172 195.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 332C218.5 332.828 217.828 333.5 217 333.5C216.172 333.5 215.5 332.828 215.5 332C215.5 331.172 216.172 330.5 217 330.5C217.828 330.5 218.5 331.172 218.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 332C241.5 332.828 240.828 333.5 240 333.5C239.172 333.5 238.5 332.828 238.5 332C238.5 331.172 239.172 330.5 240 330.5C240.828 330.5 241.5 331.172 241.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 332C264.5 332.828 263.828 333.5 263 333.5C262.172 333.5 261.5 332.828 261.5 332C261.5 331.172 262.172 330.5 263 330.5C263.828 330.5 264.5 331.172 264.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 332C287.5 332.828 286.828 333.5 286 333.5C285.172 333.5 284.5 332.828 284.5 332C284.5 331.172 285.172 330.5 286 330.5C286.828 330.5 287.5 331.172 287.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 332C310.5 332.828 309.828 333.5 309 333.5C308.172 333.5 307.5 332.828 307.5 332C307.5 331.172 308.172 330.5 309 330.5C309.828 330.5 310.5 331.172 310.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 332C333.5 332.828 332.828 333.5 332 333.5C331.172 333.5 330.5 332.828 330.5 332C330.5 331.172 331.172 330.5 332 330.5C332.828 330.5 333.5 331.172 333.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 332C356.5 332.828 355.828 333.5 355 333.5C354.172 333.5 353.5 332.828 353.5 332C353.5 331.172 354.172 330.5 355 330.5C355.828 330.5 356.5 331.172 356.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 332C379.5 332.828 378.828 333.5 378 333.5C377.172 333.5 376.5 332.828 376.5 332C376.5 331.172 377.172 330.5 378 330.5C378.828 330.5 379.5 331.172 379.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 332C402.5 332.828 401.828 333.5 401 333.5C400.172 333.5 399.5 332.828 399.5 332C399.5 331.172 400.172 330.5 401 330.5C401.828 330.5 402.5 331.172 402.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 332C425.5 332.828 424.828 333.5 424 333.5C423.172 333.5 422.5 332.828 422.5 332C422.5 331.172 423.172 330.5 424 330.5C424.828 330.5 425.5 331.172 425.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 332C448.5 332.828 447.828 333.5 447 333.5C446.172 333.5 445.5 332.828 445.5 332C445.5 331.172 446.172 330.5 447 330.5C447.828 330.5 448.5 331.172 448.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 332C471.5 332.828 470.828 333.5 470 333.5C469.172 333.5 468.5 332.828 468.5 332C468.5 331.172 469.172 330.5 470 330.5C470.828 330.5 471.5 331.172 471.5 332Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 355C11.5 355.828 10.8284 356.5 10 356.5C9.17157 356.5 8.5 355.828 8.5 355C8.5 354.172 9.17157 353.5 10 353.5C10.8284 353.5 11.5 354.172 11.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 355C34.5 355.828 33.8284 356.5 33 356.5C32.1716 356.5 31.5 355.828 31.5 355C31.5 354.172 32.1716 353.5 33 353.5C33.8284 353.5 34.5 354.172 34.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 355C57.5 355.828 56.8284 356.5 56 356.5C55.1716 356.5 54.5 355.828 54.5 355C54.5 354.172 55.1716 353.5 56 353.5C56.8284 353.5 57.5 354.172 57.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 355C80.5 355.828 79.8284 356.5 79 356.5C78.1716 356.5 77.5 355.828 77.5 355C77.5 354.172 78.1716 353.5 79 353.5C79.8284 353.5 80.5 354.172 80.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 355C103.5 355.828 102.828 356.5 102 356.5C101.172 356.5 100.5 355.828 100.5 355C100.5 354.172 101.172 353.5 102 353.5C102.828 353.5 103.5 354.172 103.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 355C126.5 355.828 125.828 356.5 125 356.5C124.172 356.5 123.5 355.828 123.5 355C123.5 354.172 124.172 353.5 125 353.5C125.828 353.5 126.5 354.172 126.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 355C149.5 355.828 148.828 356.5 148 356.5C147.172 356.5 146.5 355.828 146.5 355C146.5 354.172 147.172 353.5 148 353.5C148.828 353.5 149.5 354.172 149.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 355C172.5 355.828 171.828 356.5 171 356.5C170.172 356.5 169.5 355.828 169.5 355C169.5 354.172 170.172 353.5 171 353.5C171.828 353.5 172.5 354.172 172.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 355C195.5 355.828 194.828 356.5 194 356.5C193.172 356.5 192.5 355.828 192.5 355C192.5 354.172 193.172 353.5 194 353.5C194.828 353.5 195.5 354.172 195.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 355C218.5 355.828 217.828 356.5 217 356.5C216.172 356.5 215.5 355.828 215.5 355C215.5 354.172 216.172 353.5 217 353.5C217.828 353.5 218.5 354.172 218.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 355C241.5 355.828 240.828 356.5 240 356.5C239.172 356.5 238.5 355.828 238.5 355C238.5 354.172 239.172 353.5 240 353.5C240.828 353.5 241.5 354.172 241.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 355C264.5 355.828 263.828 356.5 263 356.5C262.172 356.5 261.5 355.828 261.5 355C261.5 354.172 262.172 353.5 263 353.5C263.828 353.5 264.5 354.172 264.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 355C287.5 355.828 286.828 356.5 286 356.5C285.172 356.5 284.5 355.828 284.5 355C284.5 354.172 285.172 353.5 286 353.5C286.828 353.5 287.5 354.172 287.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 355C310.5 355.828 309.828 356.5 309 356.5C308.172 356.5 307.5 355.828 307.5 355C307.5 354.172 308.172 353.5 309 353.5C309.828 353.5 310.5 354.172 310.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 355C333.5 355.828 332.828 356.5 332 356.5C331.172 356.5 330.5 355.828 330.5 355C330.5 354.172 331.172 353.5 332 353.5C332.828 353.5 333.5 354.172 333.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 355C356.5 355.828 355.828 356.5 355 356.5C354.172 356.5 353.5 355.828 353.5 355C353.5 354.172 354.172 353.5 355 353.5C355.828 353.5 356.5 354.172 356.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 355C379.5 355.828 378.828 356.5 378 356.5C377.172 356.5 376.5 355.828 376.5 355C376.5 354.172 377.172 353.5 378 353.5C378.828 353.5 379.5 354.172 379.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 355C402.5 355.828 401.828 356.5 401 356.5C400.172 356.5 399.5 355.828 399.5 355C399.5 354.172 400.172 353.5 401 353.5C401.828 353.5 402.5 354.172 402.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 355C425.5 355.828 424.828 356.5 424 356.5C423.172 356.5 422.5 355.828 422.5 355C422.5 354.172 423.172 353.5 424 353.5C424.828 353.5 425.5 354.172 425.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 355C448.5 355.828 447.828 356.5 447 356.5C446.172 356.5 445.5 355.828 445.5 355C445.5 354.172 446.172 353.5 447 353.5C447.828 353.5 448.5 354.172 448.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 355C471.5 355.828 470.828 356.5 470 356.5C469.172 356.5 468.5 355.828 468.5 355C468.5 354.172 469.172 353.5 470 353.5C470.828 353.5 471.5 354.172 471.5 355Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 378C11.5 378.828 10.8284 379.5 10 379.5C9.17157 379.5 8.5 378.828 8.5 378C8.5 377.172 9.17157 376.5 10 376.5C10.8284 376.5 11.5 377.172 11.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 378C34.5 378.828 33.8284 379.5 33 379.5C32.1716 379.5 31.5 378.828 31.5 378C31.5 377.172 32.1716 376.5 33 376.5C33.8284 376.5 34.5 377.172 34.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 378C57.5 378.828 56.8284 379.5 56 379.5C55.1716 379.5 54.5 378.828 54.5 378C54.5 377.172 55.1716 376.5 56 376.5C56.8284 376.5 57.5 377.172 57.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 378C80.5 378.828 79.8284 379.5 79 379.5C78.1716 379.5 77.5 378.828 77.5 378C77.5 377.172 78.1716 376.5 79 376.5C79.8284 376.5 80.5 377.172 80.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 378C103.5 378.828 102.828 379.5 102 379.5C101.172 379.5 100.5 378.828 100.5 378C100.5 377.172 101.172 376.5 102 376.5C102.828 376.5 103.5 377.172 103.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 378C126.5 378.828 125.828 379.5 125 379.5C124.172 379.5 123.5 378.828 123.5 378C123.5 377.172 124.172 376.5 125 376.5C125.828 376.5 126.5 377.172 126.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 378C149.5 378.828 148.828 379.5 148 379.5C147.172 379.5 146.5 378.828 146.5 378C146.5 377.172 147.172 376.5 148 376.5C148.828 376.5 149.5 377.172 149.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 378C172.5 378.828 171.828 379.5 171 379.5C170.172 379.5 169.5 378.828 169.5 378C169.5 377.172 170.172 376.5 171 376.5C171.828 376.5 172.5 377.172 172.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 378C195.5 378.828 194.828 379.5 194 379.5C193.172 379.5 192.5 378.828 192.5 378C192.5 377.172 193.172 376.5 194 376.5C194.828 376.5 195.5 377.172 195.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 378C218.5 378.828 217.828 379.5 217 379.5C216.172 379.5 215.5 378.828 215.5 378C215.5 377.172 216.172 376.5 217 376.5C217.828 376.5 218.5 377.172 218.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 378C241.5 378.828 240.828 379.5 240 379.5C239.172 379.5 238.5 378.828 238.5 378C238.5 377.172 239.172 376.5 240 376.5C240.828 376.5 241.5 377.172 241.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 378C264.5 378.828 263.828 379.5 263 379.5C262.172 379.5 261.5 378.828 261.5 378C261.5 377.172 262.172 376.5 263 376.5C263.828 376.5 264.5 377.172 264.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 378C287.5 378.828 286.828 379.5 286 379.5C285.172 379.5 284.5 378.828 284.5 378C284.5 377.172 285.172 376.5 286 376.5C286.828 376.5 287.5 377.172 287.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 378C310.5 378.828 309.828 379.5 309 379.5C308.172 379.5 307.5 378.828 307.5 378C307.5 377.172 308.172 376.5 309 376.5C309.828 376.5 310.5 377.172 310.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 378C333.5 378.828 332.828 379.5 332 379.5C331.172 379.5 330.5 378.828 330.5 378C330.5 377.172 331.172 376.5 332 376.5C332.828 376.5 333.5 377.172 333.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 378C356.5 378.828 355.828 379.5 355 379.5C354.172 379.5 353.5 378.828 353.5 378C353.5 377.172 354.172 376.5 355 376.5C355.828 376.5 356.5 377.172 356.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 378C379.5 378.828 378.828 379.5 378 379.5C377.172 379.5 376.5 378.828 376.5 378C376.5 377.172 377.172 376.5 378 376.5C378.828 376.5 379.5 377.172 379.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 378C402.5 378.828 401.828 379.5 401 379.5C400.172 379.5 399.5 378.828 399.5 378C399.5 377.172 400.172 376.5 401 376.5C401.828 376.5 402.5 377.172 402.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 378C425.5 378.828 424.828 379.5 424 379.5C423.172 379.5 422.5 378.828 422.5 378C422.5 377.172 423.172 376.5 424 376.5C424.828 376.5 425.5 377.172 425.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 378C448.5 378.828 447.828 379.5 447 379.5C446.172 379.5 445.5 378.828 445.5 378C445.5 377.172 446.172 376.5 447 376.5C447.828 376.5 448.5 377.172 448.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 378C471.5 378.828 470.828 379.5 470 379.5C469.172 379.5 468.5 378.828 468.5 378C468.5 377.172 469.172 376.5 470 376.5C470.828 376.5 471.5 377.172 471.5 378Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 401C11.5 401.828 10.8284 402.5 10 402.5C9.17157 402.5 8.5 401.828 8.5 401C8.5 400.172 9.17157 399.5 10 399.5C10.8284 399.5 11.5 400.172 11.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 401C34.5 401.828 33.8284 402.5 33 402.5C32.1716 402.5 31.5 401.828 31.5 401C31.5 400.172 32.1716 399.5 33 399.5C33.8284 399.5 34.5 400.172 34.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 401C57.5 401.828 56.8284 402.5 56 402.5C55.1716 402.5 54.5 401.828 54.5 401C54.5 400.172 55.1716 399.5 56 399.5C56.8284 399.5 57.5 400.172 57.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 401C80.5 401.828 79.8284 402.5 79 402.5C78.1716 402.5 77.5 401.828 77.5 401C77.5 400.172 78.1716 399.5 79 399.5C79.8284 399.5 80.5 400.172 80.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 401C103.5 401.828 102.828 402.5 102 402.5C101.172 402.5 100.5 401.828 100.5 401C100.5 400.172 101.172 399.5 102 399.5C102.828 399.5 103.5 400.172 103.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 401C126.5 401.828 125.828 402.5 125 402.5C124.172 402.5 123.5 401.828 123.5 401C123.5 400.172 124.172 399.5 125 399.5C125.828 399.5 126.5 400.172 126.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 401C149.5 401.828 148.828 402.5 148 402.5C147.172 402.5 146.5 401.828 146.5 401C146.5 400.172 147.172 399.5 148 399.5C148.828 399.5 149.5 400.172 149.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 401C172.5 401.828 171.828 402.5 171 402.5C170.172 402.5 169.5 401.828 169.5 401C169.5 400.172 170.172 399.5 171 399.5C171.828 399.5 172.5 400.172 172.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 401C195.5 401.828 194.828 402.5 194 402.5C193.172 402.5 192.5 401.828 192.5 401C192.5 400.172 193.172 399.5 194 399.5C194.828 399.5 195.5 400.172 195.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 401C218.5 401.828 217.828 402.5 217 402.5C216.172 402.5 215.5 401.828 215.5 401C215.5 400.172 216.172 399.5 217 399.5C217.828 399.5 218.5 400.172 218.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 401C241.5 401.828 240.828 402.5 240 402.5C239.172 402.5 238.5 401.828 238.5 401C238.5 400.172 239.172 399.5 240 399.5C240.828 399.5 241.5 400.172 241.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 401C264.5 401.828 263.828 402.5 263 402.5C262.172 402.5 261.5 401.828 261.5 401C261.5 400.172 262.172 399.5 263 399.5C263.828 399.5 264.5 400.172 264.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 401C287.5 401.828 286.828 402.5 286 402.5C285.172 402.5 284.5 401.828 284.5 401C284.5 400.172 285.172 399.5 286 399.5C286.828 399.5 287.5 400.172 287.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 401C310.5 401.828 309.828 402.5 309 402.5C308.172 402.5 307.5 401.828 307.5 401C307.5 400.172 308.172 399.5 309 399.5C309.828 399.5 310.5 400.172 310.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 401C333.5 401.828 332.828 402.5 332 402.5C331.172 402.5 330.5 401.828 330.5 401C330.5 400.172 331.172 399.5 332 399.5C332.828 399.5 333.5 400.172 333.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 401C356.5 401.828 355.828 402.5 355 402.5C354.172 402.5 353.5 401.828 353.5 401C353.5 400.172 354.172 399.5 355 399.5C355.828 399.5 356.5 400.172 356.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 401C379.5 401.828 378.828 402.5 378 402.5C377.172 402.5 376.5 401.828 376.5 401C376.5 400.172 377.172 399.5 378 399.5C378.828 399.5 379.5 400.172 379.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 401C402.5 401.828 401.828 402.5 401 402.5C400.172 402.5 399.5 401.828 399.5 401C399.5 400.172 400.172 399.5 401 399.5C401.828 399.5 402.5 400.172 402.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 401C425.5 401.828 424.828 402.5 424 402.5C423.172 402.5 422.5 401.828 422.5 401C422.5 400.172 423.172 399.5 424 399.5C424.828 399.5 425.5 400.172 425.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 401C448.5 401.828 447.828 402.5 447 402.5C446.172 402.5 445.5 401.828 445.5 401C445.5 400.172 446.172 399.5 447 399.5C447.828 399.5 448.5 400.172 448.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 401C471.5 401.828 470.828 402.5 470 402.5C469.172 402.5 468.5 401.828 468.5 401C468.5 400.172 469.172 399.5 470 399.5C470.828 399.5 471.5 400.172 471.5 401Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 424C11.5 424.828 10.8284 425.5 10 425.5C9.17157 425.5 8.5 424.828 8.5 424C8.5 423.172 9.17157 422.5 10 422.5C10.8284 422.5 11.5 423.172 11.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 424C34.5 424.828 33.8284 425.5 33 425.5C32.1716 425.5 31.5 424.828 31.5 424C31.5 423.172 32.1716 422.5 33 422.5C33.8284 422.5 34.5 423.172 34.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 424C57.5 424.828 56.8284 425.5 56 425.5C55.1716 425.5 54.5 424.828 54.5 424C54.5 423.172 55.1716 422.5 56 422.5C56.8284 422.5 57.5 423.172 57.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 424C80.5 424.828 79.8284 425.5 79 425.5C78.1716 425.5 77.5 424.828 77.5 424C77.5 423.172 78.1716 422.5 79 422.5C79.8284 422.5 80.5 423.172 80.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 424C103.5 424.828 102.828 425.5 102 425.5C101.172 425.5 100.5 424.828 100.5 424C100.5 423.172 101.172 422.5 102 422.5C102.828 422.5 103.5 423.172 103.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 424C126.5 424.828 125.828 425.5 125 425.5C124.172 425.5 123.5 424.828 123.5 424C123.5 423.172 124.172 422.5 125 422.5C125.828 422.5 126.5 423.172 126.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 424C149.5 424.828 148.828 425.5 148 425.5C147.172 425.5 146.5 424.828 146.5 424C146.5 423.172 147.172 422.5 148 422.5C148.828 422.5 149.5 423.172 149.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 424C172.5 424.828 171.828 425.5 171 425.5C170.172 425.5 169.5 424.828 169.5 424C169.5 423.172 170.172 422.5 171 422.5C171.828 422.5 172.5 423.172 172.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 424C195.5 424.828 194.828 425.5 194 425.5C193.172 425.5 192.5 424.828 192.5 424C192.5 423.172 193.172 422.5 194 422.5C194.828 422.5 195.5 423.172 195.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 424C218.5 424.828 217.828 425.5 217 425.5C216.172 425.5 215.5 424.828 215.5 424C215.5 423.172 216.172 422.5 217 422.5C217.828 422.5 218.5 423.172 218.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 424C241.5 424.828 240.828 425.5 240 425.5C239.172 425.5 238.5 424.828 238.5 424C238.5 423.172 239.172 422.5 240 422.5C240.828 422.5 241.5 423.172 241.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 424C264.5 424.828 263.828 425.5 263 425.5C262.172 425.5 261.5 424.828 261.5 424C261.5 423.172 262.172 422.5 263 422.5C263.828 422.5 264.5 423.172 264.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 424C287.5 424.828 286.828 425.5 286 425.5C285.172 425.5 284.5 424.828 284.5 424C284.5 423.172 285.172 422.5 286 422.5C286.828 422.5 287.5 423.172 287.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 424C310.5 424.828 309.828 425.5 309 425.5C308.172 425.5 307.5 424.828 307.5 424C307.5 423.172 308.172 422.5 309 422.5C309.828 422.5 310.5 423.172 310.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 424C333.5 424.828 332.828 425.5 332 425.5C331.172 425.5 330.5 424.828 330.5 424C330.5 423.172 331.172 422.5 332 422.5C332.828 422.5 333.5 423.172 333.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 424C356.5 424.828 355.828 425.5 355 425.5C354.172 425.5 353.5 424.828 353.5 424C353.5 423.172 354.172 422.5 355 422.5C355.828 422.5 356.5 423.172 356.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 424C379.5 424.828 378.828 425.5 378 425.5C377.172 425.5 376.5 424.828 376.5 424C376.5 423.172 377.172 422.5 378 422.5C378.828 422.5 379.5 423.172 379.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 424C402.5 424.828 401.828 425.5 401 425.5C400.172 425.5 399.5 424.828 399.5 424C399.5 423.172 400.172 422.5 401 422.5C401.828 422.5 402.5 423.172 402.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 424C425.5 424.828 424.828 425.5 424 425.5C423.172 425.5 422.5 424.828 422.5 424C422.5 423.172 423.172 422.5 424 422.5C424.828 422.5 425.5 423.172 425.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 424C448.5 424.828 447.828 425.5 447 425.5C446.172 425.5 445.5 424.828 445.5 424C445.5 423.172 446.172 422.5 447 422.5C447.828 422.5 448.5 423.172 448.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 424C471.5 424.828 470.828 425.5 470 425.5C469.172 425.5 468.5 424.828 468.5 424C468.5 423.172 469.172 422.5 470 422.5C470.828 422.5 471.5 423.172 471.5 424Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 447C11.5 447.828 10.8284 448.5 10 448.5C9.17157 448.5 8.5 447.828 8.5 447C8.5 446.172 9.17157 445.5 10 445.5C10.8284 445.5 11.5 446.172 11.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 447C34.5 447.828 33.8284 448.5 33 448.5C32.1716 448.5 31.5 447.828 31.5 447C31.5 446.172 32.1716 445.5 33 445.5C33.8284 445.5 34.5 446.172 34.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 447C57.5 447.828 56.8284 448.5 56 448.5C55.1716 448.5 54.5 447.828 54.5 447C54.5 446.172 55.1716 445.5 56 445.5C56.8284 445.5 57.5 446.172 57.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 447C80.5 447.828 79.8284 448.5 79 448.5C78.1716 448.5 77.5 447.828 77.5 447C77.5 446.172 78.1716 445.5 79 445.5C79.8284 445.5 80.5 446.172 80.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 447C103.5 447.828 102.828 448.5 102 448.5C101.172 448.5 100.5 447.828 100.5 447C100.5 446.172 101.172 445.5 102 445.5C102.828 445.5 103.5 446.172 103.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 447C126.5 447.828 125.828 448.5 125 448.5C124.172 448.5 123.5 447.828 123.5 447C123.5 446.172 124.172 445.5 125 445.5C125.828 445.5 126.5 446.172 126.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 447C149.5 447.828 148.828 448.5 148 448.5C147.172 448.5 146.5 447.828 146.5 447C146.5 446.172 147.172 445.5 148 445.5C148.828 445.5 149.5 446.172 149.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 447C172.5 447.828 171.828 448.5 171 448.5C170.172 448.5 169.5 447.828 169.5 447C169.5 446.172 170.172 445.5 171 445.5C171.828 445.5 172.5 446.172 172.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 447C195.5 447.828 194.828 448.5 194 448.5C193.172 448.5 192.5 447.828 192.5 447C192.5 446.172 193.172 445.5 194 445.5C194.828 445.5 195.5 446.172 195.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 447C218.5 447.828 217.828 448.5 217 448.5C216.172 448.5 215.5 447.828 215.5 447C215.5 446.172 216.172 445.5 217 445.5C217.828 445.5 218.5 446.172 218.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 447C241.5 447.828 240.828 448.5 240 448.5C239.172 448.5 238.5 447.828 238.5 447C238.5 446.172 239.172 445.5 240 445.5C240.828 445.5 241.5 446.172 241.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 447C264.5 447.828 263.828 448.5 263 448.5C262.172 448.5 261.5 447.828 261.5 447C261.5 446.172 262.172 445.5 263 445.5C263.828 445.5 264.5 446.172 264.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 447C287.5 447.828 286.828 448.5 286 448.5C285.172 448.5 284.5 447.828 284.5 447C284.5 446.172 285.172 445.5 286 445.5C286.828 445.5 287.5 446.172 287.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 447C310.5 447.828 309.828 448.5 309 448.5C308.172 448.5 307.5 447.828 307.5 447C307.5 446.172 308.172 445.5 309 445.5C309.828 445.5 310.5 446.172 310.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 447C333.5 447.828 332.828 448.5 332 448.5C331.172 448.5 330.5 447.828 330.5 447C330.5 446.172 331.172 445.5 332 445.5C332.828 445.5 333.5 446.172 333.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 447C356.5 447.828 355.828 448.5 355 448.5C354.172 448.5 353.5 447.828 353.5 447C353.5 446.172 354.172 445.5 355 445.5C355.828 445.5 356.5 446.172 356.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 447C379.5 447.828 378.828 448.5 378 448.5C377.172 448.5 376.5 447.828 376.5 447C376.5 446.172 377.172 445.5 378 445.5C378.828 445.5 379.5 446.172 379.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 447C402.5 447.828 401.828 448.5 401 448.5C400.172 448.5 399.5 447.828 399.5 447C399.5 446.172 400.172 445.5 401 445.5C401.828 445.5 402.5 446.172 402.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 447C425.5 447.828 424.828 448.5 424 448.5C423.172 448.5 422.5 447.828 422.5 447C422.5 446.172 423.172 445.5 424 445.5C424.828 445.5 425.5 446.172 425.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 447C448.5 447.828 447.828 448.5 447 448.5C446.172 448.5 445.5 447.828 445.5 447C445.5 446.172 446.172 445.5 447 445.5C447.828 445.5 448.5 446.172 448.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 447C471.5 447.828 470.828 448.5 470 448.5C469.172 448.5 468.5 447.828 468.5 447C468.5 446.172 469.172 445.5 470 445.5C470.828 445.5 471.5 446.172 471.5 447Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 470C11.5 470.828 10.8284 471.5 10 471.5C9.17157 471.5 8.5 470.828 8.5 470C8.5 469.172 9.17157 468.5 10 468.5C10.8284 468.5 11.5 469.172 11.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 470C34.5 470.828 33.8284 471.5 33 471.5C32.1716 471.5 31.5 470.828 31.5 470C31.5 469.172 32.1716 468.5 33 468.5C33.8284 468.5 34.5 469.172 34.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 470C57.5 470.828 56.8284 471.5 56 471.5C55.1716 471.5 54.5 470.828 54.5 470C54.5 469.172 55.1716 468.5 56 468.5C56.8284 468.5 57.5 469.172 57.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 470C80.5 470.828 79.8284 471.5 79 471.5C78.1716 471.5 77.5 470.828 77.5 470C77.5 469.172 78.1716 468.5 79 468.5C79.8284 468.5 80.5 469.172 80.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 470C103.5 470.828 102.828 471.5 102 471.5C101.172 471.5 100.5 470.828 100.5 470C100.5 469.172 101.172 468.5 102 468.5C102.828 468.5 103.5 469.172 103.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 470C126.5 470.828 125.828 471.5 125 471.5C124.172 471.5 123.5 470.828 123.5 470C123.5 469.172 124.172 468.5 125 468.5C125.828 468.5 126.5 469.172 126.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 470C149.5 470.828 148.828 471.5 148 471.5C147.172 471.5 146.5 470.828 146.5 470C146.5 469.172 147.172 468.5 148 468.5C148.828 468.5 149.5 469.172 149.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 470C172.5 470.828 171.828 471.5 171 471.5C170.172 471.5 169.5 470.828 169.5 470C169.5 469.172 170.172 468.5 171 468.5C171.828 468.5 172.5 469.172 172.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 470C195.5 470.828 194.828 471.5 194 471.5C193.172 471.5 192.5 470.828 192.5 470C192.5 469.172 193.172 468.5 194 468.5C194.828 468.5 195.5 469.172 195.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 470C218.5 470.828 217.828 471.5 217 471.5C216.172 471.5 215.5 470.828 215.5 470C215.5 469.172 216.172 468.5 217 468.5C217.828 468.5 218.5 469.172 218.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 470C241.5 470.828 240.828 471.5 240 471.5C239.172 471.5 238.5 470.828 238.5 470C238.5 469.172 239.172 468.5 240 468.5C240.828 468.5 241.5 469.172 241.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 470C264.5 470.828 263.828 471.5 263 471.5C262.172 471.5 261.5 470.828 261.5 470C261.5 469.172 262.172 468.5 263 468.5C263.828 468.5 264.5 469.172 264.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 470C287.5 470.828 286.828 471.5 286 471.5C285.172 471.5 284.5 470.828 284.5 470C284.5 469.172 285.172 468.5 286 468.5C286.828 468.5 287.5 469.172 287.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.5 470C310.5 470.828 309.828 471.5 309 471.5C308.172 471.5 307.5 470.828 307.5 470C307.5 469.172 308.172 468.5 309 468.5C309.828 468.5 310.5 469.172 310.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 470C333.5 470.828 332.828 471.5 332 471.5C331.172 471.5 330.5 470.828 330.5 470C330.5 469.172 331.172 468.5 332 468.5C332.828 468.5 333.5 469.172 333.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 470C356.5 470.828 355.828 471.5 355 471.5C354.172 471.5 353.5 470.828 353.5 470C353.5 469.172 354.172 468.5 355 468.5C355.828 468.5 356.5 469.172 356.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 470C379.5 470.828 378.828 471.5 378 471.5C377.172 471.5 376.5 470.828 376.5 470C376.5 469.172 377.172 468.5 378 468.5C378.828 468.5 379.5 469.172 379.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 470C402.5 470.828 401.828 471.5 401 471.5C400.172 471.5 399.5 470.828 399.5 470C399.5 469.172 400.172 468.5 401 468.5C401.828 468.5 402.5 469.172 402.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 470C425.5 470.828 424.828 471.5 424 471.5C423.172 471.5 422.5 470.828 422.5 470C422.5 469.172 423.172 468.5 424 468.5C424.828 468.5 425.5 469.172 425.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 470C448.5 470.828 447.828 471.5 447 471.5C446.172 471.5 445.5 470.828 445.5 470C445.5 469.172 446.172 468.5 447 468.5C447.828 468.5 448.5 469.172 448.5 470Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 470C471.5 470.828 470.828 471.5 470 471.5C469.172 471.5 468.5 470.828 468.5 470C468.5 469.172 469.172 468.5 470 468.5C470.828 468.5 471.5 469.172 471.5 470Z",
    fill: "#D0D5DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_431_5643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240 240) rotate(90) scale(240 240)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotGrid);
export default __webpack_public_path__ + "static/media/dot-grid.10ec3ecfceba21b0660267e8ff3d5d79.svg";
export { ForwardRef as ReactComponent };